// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__JYY6d","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3GMHO"};